import { useTranslation } from "react-i18next";
import TabsNavigationBar from "../../components/bar/TabsNavigationBar/TabsNavigationBar";

function FinancialReportsNavigationBar(props) {
    const { t } = useTranslation();
    return (
        <TabsNavigationBar
            multipleLocationKey={props.multipleLocationKey}
            pages={[
                {
                    label: t("headers.investment_summary"),
                    link: "/financial-panel/agreement-financial-report/",
                },
            ]}
        />
    );
}

export default FinancialReportsNavigationBar;
